import type { SubmitEvent } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDI } from '@/di/DIContext'
import { validateUsername } from '@/domain/account/validation/validateUsername'

export function useLogin() {
  const navigate = useNavigate()
  const { authService } = useDI()

  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const canSubmit = account.trim().length > 0 && password.trim().length > 0

  const handleSignIn = async (event?: SubmitEvent<HTMLFormElement>) => {
    event?.preventDefault()

    const validation = validateUsername(account)
    if (!validation.isValid) {
      setErrorMessage(validation.error!)
      return
    }

    setIsLoading(true)
    setErrorMessage('')

    try {
      const result = await authService.login({
        agentName: account,
        password,
      })

      if (!result.hasNickname) {
        navigate('/set-nickname', { replace: true })
      } else {
        navigate('/', { replace: true })
      }
    } catch (error) {
      const err = error as Error
      setErrorMessage(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword((previous) => !previous)
  }

  return {
    account,
    password,
    showPassword,
    isLoading,
    errorMessage,
    canSubmit,
    setAccount,
    setPassword,
    togglePasswordVisibility,
    handleSignIn,
  }
}
